/** 按已勾选乘车人汇总退票费用 */
export function sumSelectedRefundFee(feeData, selectedPassengerIds, orderPassengers = []) {
  if (!feeData?.available) {
    return {
      pendingSelection: false,
      ticketPriceYuan: null,
      refundFeeYuan: null,
      refundServiceFeeYuan: null,
      refundAmountYuan: null
    }
  }
  if (!selectedPassengerIds?.length) {
    const allTicketPriceYuan = orderPassengers.reduce(
      (total, p) => total + (Number(p.amount) || 0) / 100,
      0
    )
    return {
      pendingSelection: true,
      ticketPriceYuan: allTicketPriceYuan || Number(feeData.ticketPriceYuan) || 0,
      refundFeeYuan: null,
      refundServiceFeeYuan: null,
      refundAmountYuan: null
    }
  }

  const selectedIdSet = new Set(selectedPassengerIds.map(String))
  const selectedNameSet = new Set(
    orderPassengers
      .filter((p) => selectedIdSet.has(String(p.id)))
      .map((p) => p.realName)
  )
  const passengers = feeData.passengers || []
  const matched = passengers.filter(
    (p) =>
      selectedIdSet.has(String(p.passengerId)) ||
      selectedIdSet.has(String(p.id)) ||
      selectedNameSet.has(p.realName)
  )

  const sum = (key) =>
    matched.reduce((total, item) => total + (Number(item[key]) || 0), 0)

  const sumTicketPriceFromOrder = () =>
    orderPassengers
      .filter((p) => selectedIdSet.has(String(p.id)))
      .reduce((total, p) => total + (Number(p.amount) || 0) / 100, 0)

  const ticketPriceYuan = sumTicketPriceFromOrder() || sum('ticketPriceYuan')

  return {
    pendingSelection: false,
    ticketPriceYuan,
    refundFeeYuan: sum('refundFeeYuan'),
    refundServiceFeeYuan: sum('refundServiceFeeYuan'),
    refundAmountYuan: sum('refundAmountYuan')
  }
}
